// Client API du module « Réglages » (/api/reglages). En-tête émetteur des documents.

import { api } from './api'
import type { RegimeTva, ParametresFiscaux } from '@shared/schemas/reglages'

export type { RegimeTva, ParametresFiscaux }
export {
  MENTION_TVA_293B,
  REGIMES_TVA,
  LIBELLES_REGIME_TVA,
  TVA_TAUX_DEFAUT_REEL,
  URL_CANVA_ETIQUETTES_DEFAUT,
  PARAMETRES_FISCAUX_DEFAUT,
  MILLESIME_TAUX,
} from '@shared/schemas/reglages'

export interface Reglages {
  raisonSociale: string | null
  adresse: string | null
  codePostal: string | null
  ville: string | null
  pays: string
  siret: string | null
  numeroTva: string | null
  email: string | null
  telephone: string | null
  logoUrl: string | null
  mentionTva: string | null
  regimeTva: RegimeTva
  conditions: string | null
  urlAgenda: string | null
  urlCanva: string | null
  parametresFiscaux: ParametresFiscaux | null
  agendaActif: boolean
  updatedAt: string | null
}

export interface ReglagesPayload {
  raisonSociale?: string | null
  adresse?: string | null
  codePostal?: string | null
  ville?: string | null
  pays: string
  siret?: string | null
  numeroTva?: string | null
  email?: string | null
  telephone?: string | null
  logoUrl?: string | null
  mentionTva?: string | null
  regimeTva: RegimeTva
  conditions?: string | null
  urlAgenda?: string | null
  urlCanva?: string | null
  parametresFiscaux?: ParametresFiscaux | null
}

/** Lit les réglages de la cliente, ou `null` s'ils n'ont jamais été renseignés. */
export async function fetchReglages(): Promise<Reglages | null> {
  const { reglages } = await api<{ reglages: Reglages | null }>('/api/reglages')
  return reglages
}

/** Crée ou met à jour les réglages (upsert) et les renvoie. */
export async function enregistrerReglages(payload: ReglagesPayload): Promise<Reglages> {
  const { reglages } = await api<{ reglages: Reglages }>('/api/reglages', {
    method: 'PUT',
    body: JSON.stringify(payload),
  })
  return reglages
}
